export default {
	data() {
		return {
			paymentProvider: {}
		}
	},
	methods: {
		composeSignature(product_str) {
			let requestHeaders = {
				'Content-Type': 'application/json; charset=UTF-8',
				'X-Auth-Token': ''
			};
			return this.$http.get(
				'https://utils.yetvpn.com/vpn/payment/sign',
				{
					emulateJSON: true,
					params: {
						product: product_str
					},
					headers: requestHeaders
				}
			)
		},
		describeOrder(order_id) {
			let requestHeaders = {
				'Content-Type': 'application/json; charset=UTF-8',
				'X-Auth-Token': ''
			};
			return this.$http.get(
				'https://utils.yetvpn.com/vpn/payment/describe',
				{
					emulateJSON: true,
					params: {
						order_id: order_id
					},
					headers: requestHeaders
				}
			)
		},
		deleteOrder(order_id) {
			let requestHeaders = {
				'Content-Type': 'application/json; charset=UTF-8',
				'X-Auth-Token': ''
			};
			return this.$http.get(
				'https://utils.yetvpn.com/vpn/payment/clear',
				{
					emulateJSON: true,
					params: {
						order_id: order_id
					},
					headers: requestHeaders
				}
			)
		},
		initPGW() {
			Paddle.Setup({
				vendor: 50938
			});
		},
		renderCheckout(pid, email, pt, success, fail) {
			Paddle.Checkout.open({
				product: pid,
				email: email,
				passthrough: pt,
				allowQuantity: false,
				locale: 'en',
				country: 'SG',
				successCallback: (data) => {success(data)},
				closeCallback: (data) => {fail(data)}
			});
		}
	}
}